/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { AddConnectionsTableTagRelationRequestToJSON, CreateTableTagRelationRequestToJSON, RemoveConnectionsTableTagRelationRequestToJSON, TableTagRelationRepresentationFromJSON, UpdateTableTagRelationRequestToJSON, } from '../models';
/**
 *
 */
var TableTagRelationsApi = /** @class */ (function (_super) {
    __extends(TableTagRelationsApi, _super);
    function TableTagRelationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete table tag relation
     */
    TableTagRelationsApi.prototype._deleteRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tableTagRelationId === null || requestParameters.tableTagRelationId === undefined) {
                            throw new runtime.RequiredError('tableTagRelationId', 'Required parameter requestParameters.tableTagRelationId was null or undefined when calling _delete.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/tableTagRelations/{tableTagRelationId}".replace("{".concat('tableTagRelationId', "}"), encodeURIComponent(String(requestParameters.tableTagRelationId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete table tag relation
     */
    TableTagRelationsApi.prototype._delete = function (tableTagRelationId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._deleteRaw({ tableTagRelationId: tableTagRelationId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Add connections to table tag relation
     */
    TableTagRelationsApi.prototype.addConnectionsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tableTagRelationId === null || requestParameters.tableTagRelationId === undefined) {
                            throw new runtime.RequiredError('tableTagRelationId', 'Required parameter requestParameters.tableTagRelationId was null or undefined when calling addConnections.');
                        }
                        if (requestParameters.addConnectionsTableTagRelationRequest === null ||
                            requestParameters.addConnectionsTableTagRelationRequest === undefined) {
                            throw new runtime.RequiredError('addConnectionsTableTagRelationRequest', 'Required parameter requestParameters.addConnectionsTableTagRelationRequest was null or undefined when calling addConnections.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/tableTagRelations/{tableTagRelationId}/connections".replace("{".concat('tableTagRelationId', "}"), encodeURIComponent(String(requestParameters.tableTagRelationId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: AddConnectionsTableTagRelationRequestToJSON(requestParameters.addConnectionsTableTagRelationRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Add connections to table tag relation
     */
    TableTagRelationsApi.prototype.addConnections = function (tableTagRelationId, addConnectionsTableTagRelationRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addConnectionsRaw({
                            tableTagRelationId: tableTagRelationId,
                            addConnectionsTableTagRelationRequest: addConnectionsTableTagRelationRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create table tag relation
     */
    TableTagRelationsApi.prototype.createRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createTableTagRelationRequest === null ||
                            requestParameters.createTableTagRelationRequest === undefined) {
                            throw new runtime.RequiredError('createTableTagRelationRequest', 'Required parameter requestParameters.createTableTagRelationRequest was null or undefined when calling create.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/tableTagRelations",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: CreateTableTagRelationRequestToJSON(requestParameters.createTableTagRelationRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TableTagRelationRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create table tag relation
     */
    TableTagRelationsApi.prototype.create = function (createTableTagRelationRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRaw({ createTableTagRelationRequest: createTableTagRelationRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetch table tag relation
     */
    TableTagRelationsApi.prototype.getRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tableTagRelationId === null || requestParameters.tableTagRelationId === undefined) {
                            throw new runtime.RequiredError('tableTagRelationId', 'Required parameter requestParameters.tableTagRelationId was null or undefined when calling get.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/tableTagRelations/{tableTagRelationId}".replace("{".concat('tableTagRelationId', "}"), encodeURIComponent(String(requestParameters.tableTagRelationId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TableTagRelationRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fetch table tag relation
     */
    TableTagRelationsApi.prototype.get = function (tableTagRelationId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRaw({ tableTagRelationId: tableTagRelationId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find all table tag relations
     */
    TableTagRelationsApi.prototype.listRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/tableTagRelations",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return jsonValue.map(TableTagRelationRepresentationFromJSON);
                            })];
                }
            });
        });
    };
    /**
     * Find all table tag relations
     */
    TableTagRelationsApi.prototype.list = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Remove connections to table tag relation
     */
    TableTagRelationsApi.prototype.removeConnectionsRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tableTagRelationId === null || requestParameters.tableTagRelationId === undefined) {
                            throw new runtime.RequiredError('tableTagRelationId', 'Required parameter requestParameters.tableTagRelationId was null or undefined when calling removeConnections.');
                        }
                        if (requestParameters.removeConnectionsTableTagRelationRequest === null ||
                            requestParameters.removeConnectionsTableTagRelationRequest === undefined) {
                            throw new runtime.RequiredError('removeConnectionsTableTagRelationRequest', 'Required parameter requestParameters.removeConnectionsTableTagRelationRequest was null or undefined when calling removeConnections.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/tableTagRelations/{tableTagRelationId}/connections".replace("{".concat('tableTagRelationId', "}"), encodeURIComponent(String(requestParameters.tableTagRelationId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                                body: RemoveConnectionsTableTagRelationRequestToJSON(requestParameters.removeConnectionsTableTagRelationRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Remove connections to table tag relation
     */
    TableTagRelationsApi.prototype.removeConnections = function (tableTagRelationId, removeConnectionsTableTagRelationRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeConnectionsRaw({
                            tableTagRelationId: tableTagRelationId,
                            removeConnectionsTableTagRelationRequest: removeConnectionsTableTagRelationRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update table tag relation
     */
    TableTagRelationsApi.prototype.updateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.tableTagRelationId === null || requestParameters.tableTagRelationId === undefined) {
                            throw new runtime.RequiredError('tableTagRelationId', 'Required parameter requestParameters.tableTagRelationId was null or undefined when calling update.');
                        }
                        if (requestParameters.updateTableTagRelationRequest === null ||
                            requestParameters.updateTableTagRelationRequest === undefined) {
                            throw new runtime.RequiredError('updateTableTagRelationRequest', 'Required parameter requestParameters.updateTableTagRelationRequest was null or undefined when calling update.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/tableTagRelations/{tableTagRelationId}".replace("{".concat('tableTagRelationId', "}"), encodeURIComponent(String(requestParameters.tableTagRelationId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateTableTagRelationRequestToJSON(requestParameters.updateTableTagRelationRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return TableTagRelationRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update table tag relation
     */
    TableTagRelationsApi.prototype.update = function (tableTagRelationId, updateTableTagRelationRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRaw({
                            tableTagRelationId: tableTagRelationId,
                            updateTableTagRelationRequest: updateTableTagRelationRequest,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return TableTagRelationsApi;
}(runtime.BaseAPI));
export { TableTagRelationsApi };
